import { Helmet } from 'react-helmet';
import { Backdrop, Box, Container, Grid, Card, CardContent, Typography, CardHeader, Button, Divider, IconButton, TextField, MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useEffect } from 'react';
import { useBackDrop } from 'src/provider/BackdropProvider';
import { useState } from 'react';
import useApi from 'src/api/api';
import { ArrowBack } from '@material-ui/icons';
import Icons from 'src/icons';
import DataTable from 'src/components/DataTable/DataTable';
import DataTableNoLimit from 'src/components/DataTable/DataTableNoLimit';
import _ from 'lodash';
import { useNavigate } from 'react-router';
import { useLocale } from 'src/provider/LocaleProvider';
import SearchInput from 'src/components/SearchInput';
import utils from 'src/utils/utils';
import LayoutContainer from 'src/layout/LayoutContainer';
import { useAuthData } from 'src/provider/AuthDataProvider';
import { getLanguage } from 'react-switch-lang';
const moment = require('moment-timezone')

const useStyles = makeStyles(theme => ({

    row: {
        // height: '10px',
        // paddingBottom: theme.spacing(2),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(2)
    },
    spacer: {
        flex: 1
    },
    tableCell: {
        "& .MuiTableCell-root": {
            textAlign: 'center',
            borderLeft: "none !important",
        },
        "& .MuiTableRow-root": {
            height: '60px'
        },

    },
    caption: {
        fontSize: '12px'
    }

}))



function sortRank(data, selectedCategory) {
    var temp
    if (selectedCategory && selectedCategory !== 'null') {
        temp = _.map(data, r => {
            var p = _.find(r?.pointsByRuleCategories, { ruleCategory_id: selectedCategory })
            if (p) {
                return ({ ...r, point: p.total || 0 })
            }
            return ({ ...r, point: 0 })
        })
    }
    else {
        temp = _.map(data, r => ({ ...r, point: r.totalpoints || 0 }))
    }
    temp = _.orderBy(temp, 'point', 'desc')
    return temp
}



const UserRanking = () => {
    const classes = useStyles()
    const loadingView = useBackDrop();
    const api = useApi()
    const nav = useNavigate()
    const { t, getLanguage } = useLocale()
    const { selectedPeriod, organization } = useAuthData()
    const [userRanking, setUserRanking] = useState([])
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('null');


    const handleExport = () => {
        utils.exportCsv(userRanking, [
            { label: t('rank'), value: (row) => { return (_.findIndex(userRanking, (k) => k.user === row.user) + 1) } },
            { label: t('class'), value: row => row['class'], },
            { label: t('name_zh'), value: row => row.name?.zh },
            { label: t('name_en'), value: row => row.name?.en, },
            { label: t('total_point'), value: row => row['totalpoints'] }
        ], 'user_ranking')
    }

    useEffect(() => {
        api.getPointRuleCategories({ setCategories })
    }, []);

    useEffect(() => {
        var temp = sortRank(userRanking, selectedCategory)
        setUserRanking(temp)
    }, [selectedCategory]);

    useEffect(async () => {
        if (selectedPeriod) {
            api.getUserRanking(selectedPeriod).then(({ data }) => {
                var temp = sortRank(data, selectedCategory)
                setUserRanking(temp)
            })
        }
    }, [selectedPeriod])
    return (
        <LayoutContainer title={t('studentRankTable_title')} backSrc='/admin/dashboard'>
            <Grid container spacing={1} alignItems="center" sx={{ mb: 2 }} >
                <Grid item xs>
                    <TextField
                        size='small'
                        select
                        fullWidth
                        value={selectedCategory}
                        label={t('rule_category')}
                        sx={{ maxWidth: '500px' }}
                        onChange={e => setSelectedCategory(e.target.value)}
                    >
                        <MenuItem value={'null'}> {t('all_rule_category')} </MenuItem>
                        {_.map(categories, c => {
                            return <MenuItem key={c._id} value={c._id}> {_.get(c, 'name.' + getLanguage())} </MenuItem>
                        })}
                    </TextField>
                </Grid>
                <Grid item >
                    <Button onClick={handleExport} >
                        {t('export')}
                    </Button>
                </Grid>
            </Grid>
            <DataTable
                sx={{ mb: 1 }}
                className={classes.tableCell}
                rows={userRanking}
                heads={[
                    { label: t('rank'), value: 'rank', content: (row, index) => { return (_.findIndex(userRanking, (k) => k.user === row.user) + 1) } },
                    { label: t('class'), value: 'class', },
                    { label: t('name_zh'), value: 'name.zh' },
                    { label: t('name_en'), value: 'name.en', },
                    { label: t('total_point'), value: 'point' }
                ]}

            />
            <div align='right' className={'font12'}>Last Updated at {moment().format("YYYY-MM-DD HH:mm:ss")}</div>

        </LayoutContainer >)
}
export default UserRanking;
